import text, { getText } from './text';
import recentBoardIds from './recent-board-ids';
import utils from './utils';

const help = {
	async saveMultiplayerAd(params = {}, logs = []) {
		let $store = params.$store;
		let blockId = params.blockId;
		let selected = params.selected || [];

		let obj = {
			blockId: blockId,
			boards: selected || [],
		};

		try {
			const response = await $store.dispatch('ads/add', obj).catch((err) => {});
			return response;
		} catch (err) {
			let errorText = 'Scraping error';
			if (err.response) {
				if (err.response.status === 401) {
					errorText = getText('errorAuth');
				}
				if (err.response.status === 403) {
					errorText = getText('errorPay');
				}
				if (err.response.status === 405) {
					errorText = getText('errorEmailVerificationPending');
				}
			}

			throw errorText;
		}
	},
	async saveExtensionAd(params = {}, logs = []) {
		let type = params.type || 'facebook';
		let target = params.target;
		let baseUrl = params.baseUrl;
		let selected = params.selected;
		//let target = this.$parent.parentElement; //e.target;
		let errorMessage = '';

		let data = null;
		let saving = true;

		logs.push('extracting data');

		try {
			data = extractData(target, baseUrl);
			logs.push(`Data successfully extracted`);
		} catch (err) {
			logs.push(`Extracting data failed. Error: ${err}`);
			console.log(err);
			if (err) {
				errorMessage = err;
			} else {
				errorMessage = getText('error');
			}

			throw getText(errorMessage);
		}

		let payload = null;

		logs.push(`Forming dataset based on type: ${type}`);

		try {
			if (type === 'facebook') {
				payload = await facebook(data, target);
			}
			if (type === 'linkedin') {
				payload = await linkedin(data, target);
			}
			if (type === 'tiktok-top-ads') {
				payload = await tiktokTopAds(data, target);
			}
			if (type === 'tiktok-library') {
				payload = await tiktokLibrary(data, target);
			}
			if (type === 'tiktok-feed') {
				payload = await tiktokFeed(data, target);
			}
			if (type === 'pinterest' || type === 'google') {
				throw "Pinterest/Google aren't supported";
			}
			// if (type === 'pinterest') {
			// 	payload = await pinterest(data, target);
			// }
			// if (type === 'google') {
			// 	payload = await google(data, target);
			// }
		} catch (err) {
			logs.push(`Dataset formation failed. Error:${err}`);
			console.log(err);
			throw err;
		}

		let response = null;

		payload.boards = selected;

		if (!data) {
			logs.push(`Couldn't parse data. data.length:${data.length}`);
			throw `couldn't parse data`;
		}

		try {
			response = await utils.saveAd(baseUrl, payload);
		} catch (err) {
			console.log(err);
			throw err;
		}

		return response;
	},
};

async function linkedin(data, target) {
	data.type = 'linkedin';

	let payload = {
		...data,
	};

	return payload;
}
async function tiktokTopAds(data, target) {
	let url = data.assets[0].assetPath;

	if (data.type === 'tiktok') {
		let video = await utils.loadVideo(url);

		if (video) {
			data.files = video;
		}
	}

	return data;
}
async function tiktokLibrary(data, target) {
	return data;
}
async function tiktokFeed(data, target) {
	data.type = 'tiktok';
	return data;
}
async function facebook(data, target) {
	data.assetRatio = await utils.getRatio(target);
	data.assets = data.assets || [];

	let image = await utils.getImage(target);

	if (image) {
		data.assets.push({
			type: 'image',
			assetPath: image,
		});
	}

	let standaloneImage = await utils.getStandaloneImage(target);

	if (standaloneImage) {
		data.assets.push({
			type: 'image',
			assetPath: standaloneImage,
		});
	}

	let video = await utils.getVideo(target);

	if (!video) {
		let carousel = await utils.getCarousel(target);

		if (carousel) {
			data.assets = data.assets.concat(carousel);
		}
	}

	if (video) {
		data.assets.push({
			type: 'video',
			assetPath: video,
		});
	}

	let isEuAd = await utils.getIsEuAd(target);

	data.isEuAd = isEuAd || false;

	let payload = {
		type: 'facebook',
		meta: data,
	};

	return payload;
}

function extractData(target, baseurl) {
	let data = null;

	try {
		data = target.dataset.value;
	} catch (err) {
		console.log('Extension context invalidated');
		// event(this.baseurl, {
		// 	name: 'user.error',
		// 	errorMessage: `extension context invalidated`,
		// 	url: window.location.href,
		// });
		throw 'Refresh page';
	}

	try {
		data = JSON.parse(data);
	} catch (err) {
		console.log('JSON parsing error');
		// event(baseurl, {
		// 	name: 'user.error',
		// 	errorMessage: `Couldn't parse JSON while saving ad`,
		// 	url: window.location.href,
		// });
		throw '';
	}

	return data;
}

export default help;
